import React from "react";
import "./newloader.scss";

const NewLoader = () => {
  return (
    <div className="loader">
      <div className="face face1">
        <div className="circle"></div>
      </div>
      <div className="face face2">
        <div className="circle"></div>
      </div>
    </div>
  );
};

export default NewLoader;
